import { createElement } from "react";
import React from "react";
import { round, createObj } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { labeledHidden, labeled, handleEvent, debouncer } from "./Prelude.js";
import { ofArray } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { forAll, empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { unwrap, defaultArg, toArray, value as value_20 } from "../fable_modules/fable-library-js.4.29.0/Option.js";

export function floatRange(precision, min, max, value, dispatch) {
    let handler;
    return createElement("input", createObj(ofArray([["type", "range"], ["min", min], ["max", max], ["step", precision], ["value", value], (handler = debouncer(5, dispatch), ["onChange", (ev) => {
        const value_10 = ev.target.valueAsNumber;
        if (!(value_10 == null) && !Number.isNaN(value_10)) {
            handler(value_10);
        }
    }])])));
}

export function natRange(min, max, value, dispatch) {
    return floatRange(1, min, max, value, (arg) => {
        dispatch(arg >>> 0);
    });
}

function NumberInput(props) {
    const patternInput = reactApi.useState([props.Value, true]);
    const value = patternInput[0][0];
    const setState = patternInput[1];
    const updateInput = () => {
        setState([value, !patternInput[0][1]]);
    };
    const dependencies = [props.Value];
    reactApi.useEffect(() => {
        if (props.Value !== value) {
            setState([props.Value, true]);
        }
    }, dependencies);
    return createElement("input", createObj(toList(delay(() => append(singleton(["className", "input-box"]), delay(() => append(singleton(["style", {
        width: props.Width,
    }]), delay(() => append(singleton(["type", "number"]), delay(() => append((props.Min != null) ? singleton(["min", value_20(props.Min)]) : empty(), delay(() => append((props.Max != null) ? singleton(["max", value_20(props.Max)]) : empty(), delay(() => append(singleton(["step", props.Precision]), delay(() => append(singleton(["value", value]), delay(() => append(singleton(["onChange", (ev) => {
        const value_16 = ev.target.valueAsNumber;
        if (!(value_16 == null) && !Number.isNaN(value_16)) {
            const p = 1 / props.Precision;
            const v_1 = round(value_16 * p) / p;
            if (((v_1 !== value) && forAll((m) => (m <= v_1), toArray(props.Min))) && forAll((m_1) => (v_1 <= m_1), toArray(props.Max))) {
                props.Dispatch(v_1);
            }
        }
    }]), delay(() => append(singleton(["onBlur", (_arg) => {
        updateInput();
    }]), delay(() => singleton(["onKeyDown", (e) => {
        const matchValue = e.key;
        switch (matchValue) {
            case "Enter":
            case "Escape": {
                handleEvent(e);
                updateInput();
                break;
            }
            default:
                undefined;
        }
    }])))))))))))))))))))))));
}

export function natWith(width, min, max, value, dispatch) {
    let Min;
    return createElement(NumberInput, (Min = defaultArg(min, 0), {
        Dispatch: (arg) => {
            dispatch(arg >>> 0);
        },
        Max: defaultArg(max, 4294967295),
        Min: unwrap(Min),
        Precision: 1,
        Value: value,
        Width: width,
    }));
}

export function float(width, precision, min, max, value, dispatch) {
    return createElement(NumberInput, {
        Dispatch: dispatch,
        Max: unwrap(max),
        Min: unwrap(min),
        Precision: precision,
        Value: value,
        Width: width,
    });
}

function numberWithRange(label, number, range) {
    let elems;
    return createElement("span", createObj(ofArray([["className", "number-and-range"], (elems = [labeled(label, number), labeledHidden(label, range)], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function floatWithRange(label, width, precision, min, max, value, dispatch) {
    return numberWithRange(label, float(width, precision, min, max, value, dispatch), floatRange(precision, min, max, value, dispatch));
}

export function natWithRange(label, width, min, max, value, dispatch) {
    return numberWithRange(label, natWith(width, min, max, value, dispatch), natRange(min, max, value, dispatch));
}

export function text(value, dispatch) {
    return createElement("input", {
        className: "input-box",
        type: "text",
        value: value,
        onChange: (ev) => {
            dispatch(ev.target.value);
        },
    });
}

export function checkboxWith(children, value, dispatch) {
    let elems;
    return createElement("label", createObj(ofArray([["className", "checkbox"], (elems = [createElement("input", {
        type: "checkbox",
        checked: value,
        onChange: (ev) => {
            dispatch(ev.target.checked);
        },
    }), createElement("img", {
        alt: "",
    }), children], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function checkbox(text_1, value, dispatch) {
    return checkboxWith(createElement("span", {
        children: [text_1],
    }), value, dispatch);
}

export function checkboxHiddenText(labelText, value, dispatch) {
    let elems;
    return createElement("label", createObj(ofArray([["className", "checkbox"], (elems = [createElement("span", {
        className: "hidden-text",
        children: labelText,
    }), createElement("input", {
        type: "checkbox",
        checked: value,
        onChange: (ev) => {
            dispatch(ev.target.checked);
        },
    }), createElement("img", {
        alt: "",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

//# sourceMappingURL=Input.js.map
